import { InjectionToken } from "@angular/core";
import { loadStripe } from "@stripe/stripe-js";

export type StripeLoader = typeof loadStripe;

export const STRIPE_LOADER = new InjectionToken<StripeLoader>("STRIPE_LOADER", {
  providedIn: "root",
  factory: () => loadStripe,
});
